const focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"]';
export const getFirstFocusable = (parent) => parent.querySelector(focusableSelectors);
export const getAllFocusableElements = (parent) => parent.querySelectorAll(focusableSelectors);
